import { User01 } from '@untitledui/icons';
import { useGcsStore } from '../../../store/useGcsStore';
import { Text } from '../../../components/general/Text';
import { Icon } from '../../../components/general/Icon';

interface CurrentUserTileProps {
  gcsId: string;
}

function CurrentUserTile({ gcsId }: CurrentUserTileProps) {
  const user = useGcsStore((state) => state.data.get(gcsId)?.user.data);

  if (!user) {
    return null;
  }

  return (
    <div
      style={{
        padding: '12px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '8px'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Icon icon={User01} size={16} />
        <Text variant='body2-medium'>{user.name}</Text>
      </div>
      <Text variant='body2-medium' style={{ color: 'var(--text-secondary)' }}>
        {user.email}
      </Text>
    </div>
  );
}

export default CurrentUserTile;
